<template>
  <div class="empty-container">
    <div class="empty-inner">
      <div class="empty-img">
        <img width="144" height="133" src="@/assets/empty.png">
      </div>
      <div class="empty-text">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "暂无数据"
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-container {
  background: #fbfbfb;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
}
.empty-inner {
  width: 144px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.empty-img {
  width: 100%;
}
.empty-text {
  text-align: center;
  color: #999999;
  font-size: 12px;
  margin-top: 10px;
}
</style>
